document.addEventListener("DOMContentLoaded", function () {
    const banners = document.querySelectorAll('.promo-banner');
    if (!banners.length) return;

    function setBannerMessage(message) {
        banners.forEach(banner => {
            const content = banner.querySelector('.promo-banner__content p, .free-shipping-promo');
            if (content) {
                content.textContent = message;
                banner.style.display = "block";
            }
        });
    }

    function applyFreeShippingMessage() {
        const apply = (data) => {
            const country = (window.Shopify && window.Shopify.country) || data?.detected_values?.country?.handle;
            const isUS = !country || country === 'US';
            const freeShippingAmount = window.liaisonFreeShippingAmount
                ? window.liaisonFreeShippingAmount(isUS)
                : (isUS ? '$50' : '$70');

            setBannerMessage(`FREE SHIPPING OVER ${freeShippingAmount}`);
        };

        if (typeof getVisitorBrowsingContext === 'function') {
            getVisitorBrowsingContext().then(apply).catch(() => apply(null));
            return;
        }

        apply(null);
    }

    fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => response.json())
    .then(cart => {
        let hasSaleItem = false;

        if (cart.items && cart.items.length > 0) {
            for (let i = 0; i < cart.items.length; i++) {
                const title = cart.items[i].product_title;
                if (title && title.toLowerCase().includes('sale')) {
                    hasSaleItem = true;
                    break;
                }
            }
        }

        if (hasSaleItem) {
            setBannerMessage("SPECIAL SALE – NO CODE REQUIRED – ENDS");
            return;
        }

        applyFreeShippingMessage();
    })
    .catch(error => {
        console.error('Error fetching cart:', error);
        applyFreeShippingMessage();
    });
});
